import { combineReducers } from 'redux';

import { deployReducer } from './deploy';

export const reducer = combineReducers({
  deploy: deployReducer,
});

export type State = ReturnType<typeof reducer>;
